function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg10D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "10d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.306,
    height: 33.592,
    viewBox: "0 0 30.306 33.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184503"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184502"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184498"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14447",
    d: "M268.293 191.2a4.456 4.456 0 0 0-4.4-3.447 4.58 4.58 0 0 0-2.8.948 7.975 7.975 0 0 0-7.125-4.267 7.845 7.845 0 0 0-7.876 6.669 5.3 5.3 0 0 0-4.247 5.1 5.35 5.35 0 0 0 5.433 5.23h19.439a5.35 5.35 0 0 0 5.433-5.23 5.278 5.278 0 0 0-3.857-5.003z",
    transform: "translate(-241.843 -179.017)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14524",
    d: "M285.565 46.889a5.164 5.164 0 0 1 2.6-.688 5.1 5.1 0 0 1 4.9 3.58 6.032 6.032 0 0 1 .621.267 6.777 6.777 0 1 0-11.386-6.179 8.372 8.372 0 0 1 3.265 3.02z",
    transform: "translate(-265.905 -38.43)",
    style: {
      fill: "#ff8826"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184501"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184499"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14448",
    d: "M266.032 191.276a6.3 6.3 0 0 1 5.1-2.723.377.377 0 0 0 0-.754 7.1 7.1 0 0 0-5.754 3.1c-.279.4.375.776.652.381z",
    transform: "translate(-259.034 -181.479)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184500"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14449",
    d: "M246.367 218.179a4.1 4.1 0 0 1 1.922-3.416c.408-.261.03-.914-.381-.651a4.88 4.88 0 0 0-2.3 4.067.377.377 0 0 0 .754 0z",
    transform: "translate(-244.604 -200.709)",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184514"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184505"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184504"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14451",
    d: "m277.165 252.286 1.962 3.093c.23.363.809.027.578-.338l-1.962-3.093c-.23-.362-.809-.027-.578.338z",
    transform: "translate(-267.676 -228.353)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184507"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184506"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14452",
    d: "m293.528 255.471 1.962 3.093c.23.363.809.027.578-.338l-1.962-3.093c-.23-.362-.809-.027-.578.338z",
    transform: "translate(-279.662 -230.687)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184509"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184508"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14453",
    d: "m289.429 273.061 1.962 3.093c.23.363.809.027.578-.338l-1.962-3.093c-.23-.363-.809-.027-.578.338z",
    transform: "translate(-276.659 -243.57)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184511"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184510"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14454",
    d: "m274.475 267.727 1.962 3.093c.23.362.809.027.578-.338l-1.962-3.093c-.23-.363-.809-.027-.578.338z",
    transform: "translate(-265.705 -239.663)",
    style: {
      fill: "#283593"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184513"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184512"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14455",
    d: "m305.792 276.246 1.962 3.093c.23.363.809.027.578-.338l-1.962-3.093c-.23-.362-.809-.027-.578.338z",
    transform: "translate(-288.645 -245.903)",
    style: {
      fill: "#283593"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10D);
export default __webpack_public_path__ + "static/media/10D.0c3a5a7fa57e3e532cbb70970a37f611.svg";
export { ForwardRef as ReactComponent };